import {
  getRecommendSong,
  delRecommendSong,
  editRecommendSong,
  saveMultyRecommendSong,
} from '@/services/MusicLibrary/remoteResource';

export default {
  namespace: 'RecommendSong',

  state: {
    data: {},
    visible: false,
    current: [],
    sortedInfo: '',
    result: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const { status, data } = yield call(getRecommendSong, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },
    *del({ payload }, { call, put }) {
      const { status, data } = yield call(delRecommendSong, payload);
      if (status === 200) {
        yield put({
          type: 'saveResult',
          payload: data,
        });
      }
    },
    *edit({ payload }, { call, put }) {
      const { status, data } = yield call(editRecommendSong, payload);
      if (status === 200) {
        yield put({
          type: 'saveResult',
          payload: data,
        });
      }
    },
    *saveMulty({ payload }, { call, put }) {
      const { status, data } = yield call(saveMultyRecommendSong, payload);
      if (status === 200) {
        yield put({
          type: 'saveResult',
          payload: data,
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
    saveResult(state, { payload }) {
      return {
        ...state,
        result: payload,
      };
    },
  },
};
